import { FormEvent } from 'react'
import classNames from 'classnames'

import FieldWrapper from '../FieldWrapper'
import style from './style.scss'

type Props = {
  className?: string
  disabled?: boolean
  name: string
  value: string
  labelText: string
  onChange: (data: { name: string; value: string }) => void
  options: { key: string; value: string }[]
  id: string
}

function Select(props: Props) {
  const {
    id,
    className,
    labelText,
    name,
    value,
    disabled = false,
    onChange,
    options,
  } = props

  const handleChange = (e: FormEvent<HTMLSelectElement>) => {
    onChange({ name: e.currentTarget.name, value: e.currentTarget.value })
  }

  return (
    <FieldWrapper className={classNames(style.wrapper, className)}>
      <select
        className={style.select}
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        data-testid={`${name}-select`}
      >
        <option value=''>{labelText}</option>
        {options.map(({ key, value }, index) => (
          <option key={index} className={style.option} value={key}>
            {value}
          </option>
        ))}
      </select>
    </FieldWrapper>
  )
}

export default Select
